import { consentListeners } from './consentListeners';

export const initCMP = (site: string) => {
  const cmpAllowlist: string[] =[
    'https://selbsttest.netdoktor.de',
    'https://selbsttest.netdoktor.at',
    'https://selbsttest.netdoktor.ch',
    'https://selbsttest.mylife.de',
    // 'https://selbsttest.gesundheitsportal-privat.de',
    'https://stage.selbsttest.netdoktor.de',
    'https://stage.selbsttest.netdoktor.at',
    'https://stage.selbsttest.netdoktor.ch',
    'https://stage.selbsttest.mylife.de',
    // 'https://stage.selbsttest.gesundheitsportal-privat.de',
  ];

  if (cmpAllowlist.indexOf(site) === -1) {
    throw new Error(`There is no CMP configuration for ${site}`);
  }

  consentListeners();
};
